import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ConsentBarChart from '../metrics/ConsentBarChart';
import DashboardConsentPie from '../metrics/DashbaordConsentPie';
import GlobalVendorConsent from '../metrics/GlobalVendorConsent';
import VendorConsentByOs from '../metrics/VendorConsentByOs';

const AdminDashboardConsentTab = ({filter}) => {
	const { t } = useTranslation();

  return (<>
    <Row>
      <Col>
        <GlobalVendorConsent filter={filter}/>
      </Col>
      <Col>
        <DashboardConsentPie source={"active_devices"} title={t("publisher.consentAllDevices")} filter={filter}/>
      </Col>
      <Col>
        <DashboardConsentPie source={"location_authorized_devices"} title={t("publisher.location_authorized_devices")} filter={filter}/>
      </Col>
    </Row>
    <Row>
      <Col>
        <VendorConsentByOs filter={filter}/>
      </Col>
      <Col>
        <ConsentBarChart source={"active_devices"} title={t("publisher.optInPerOs")} filter={filter}/>
      </Col>
      <Col>
        <ConsentBarChart source={"location_authorized_devices"} title={t("publisher.optInLocalisationPerOs")} filter={filter}/>
      </Col>
    </Row>
  </>)
}

export default AdminDashboardConsentTab